// extracted by mini-css-extract-plugin
export default {"cls1":"tS8ucKaByJLeCR77SR1b","cls2":"ir8uBq6tFrdrYBPVy8mT tS8ucKaByJLeCR77SR1b"};